/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import o from"../core/Error.js";function e(e){if(e&&"object"==typeof e&&"type"in e&&"mesh"===e.type)throw new o("Mesh geometries are not supported for this operation")}function r(o){o.forEach(e)}export{e as assertNotMesh,r as assertNotMeshes};
